import * as types from "../constants/officeRunnerConstants";

export default function(state = null, action) {
  switch (action.type) {
    case types.CREATE_LEAD_ERROR:
      return action.error;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leadErrorReducer.js